import '@mantine/core/styles.css';
import './tokens.css';
import './styles.css';
import { createTheme, MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Component, StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });
const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'var(--font-body)',
  fontFamilyMonospace: 'var(--font-mono)',
  headings: { fontFamily: 'var(--font-display)', fontWeight: '700' },
  defaultRadius: 'md',
  cursorType: 'pointer',
});

// Replace existing offline workers with a one-time cleanup; no new offline shell.
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then(registrations => Promise.all(
    registrations.filter(registration => ['/', '/diagnostics/'].includes(new URL(registration.scope).pathname))
      .map(registration => navigator.serviceWorker.register(
        new URL(registration.scope).pathname === '/' ? '/sw.js' : '/diagnostics/sw.js',
        { scope: new URL(registration.scope).pathname, updateViaCache: 'none' },
      )),
  )).catch(() => {});
}

class StartupBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <main>
      <h1>FEDA VPN</h1>
      <p>Не удалось загрузить страницу. <a href="/?reload=1">Обновить</a></p>
      <p><a href="/auth/login">Войти</a></p>
    </main>;
    return this.props.children;
  }
}

createRoot(document.getElementById('root')!).render(
  <StartupBoundary>
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <App />
      </MantineProvider>
    </QueryClientProvider>
  </StrictMode>
  </StartupBoundary>,
);
